import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "appliances" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "appliances__header d-flex fle-column flex-md-row align-items-start align-items-md-end justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "appliances__header__heading" }, "Smart Status")
], -1)
const _hoisted_3 = { class: "appliances__filters-container" }
const _hoisted_4 = { class: "appliances__table-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmartStatusAppliancesFilter = _resolveComponent("SmartStatusAppliancesFilter")!
  const _component_SmartStatusAppliancesTable = _resolveComponent("SmartStatusAppliancesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SmartStatusAppliancesFilter)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SmartStatusAppliancesTable)
    ])
  ]))
}